import React from 'react';
import { about } from '../data';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="section-header">
        <div>
          <h2 className="section-title">About & Vision</h2>
          <p className="section-subtitle">Where I'm heading</p>
        </div>
      </div>

      <div className="about-grid">
        <div className="about-card">
          <h3 className="about-title">👨‍💻 Background</h3>
          {about.background.split('\n\n').map((paragraph, index) => (
            <p key={index} className="about-text">{paragraph}</p>
          ))}
        </div>

        <div className="about-card featured">
          <h3 className="about-title">🎯 Vision & Goals</h3>
          <p className="about-text">
            My long-term vision is to build a company that delivers advanced AI-driven solutions tailored for the finance sector. I aim to develop intelligent systems that empower businesses to make faster, more accurate, and data-driven financial decisions, also:
          </p>
          <ul className="goal-list">
            {about.goals.map((goal, index) => (
              <li key={index}>
                <span className="goal-bullet"></span>
                <span>{goal}</span>
              </li>

            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
